import { Fragment } from 'react';
import { useSelector } from 'react-redux';
import VirtualizedThreadListMemberList from '../../thread-list-member-sidebar/components/VirtualizedThreadListMemberList';
import { useSortOrder, useSearchAndFilterThreadListMembers } from 'find-and-filter-data/search-and-filter-data/public';
import { selectFilteredThreadListMemberWithThreadId, selectFilterValues } from 'find-and-filter-data/search-and-filter-data/protected';
import { FilterKey } from 'find-and-filter-data/search-and-filter-schema/protected';
import { useNavigateToThread } from '../hooks/useNavigateToThread';
import DisplayResultsText from '../../thread-list-member-sidebar/components/DisplayResultsText';
import { getCurrentInboxId } from 'conversations-inbox-lib/unified-inbox/public/selectors';
import { trackAppliedFilters } from '../operators/trackAppliedFilters';
import { useMarkViewMemberSeen } from 'find-and-filter-data/view-members-data/public';
import PortalIdParser from 'PortalIdParser';
import { ThreadListMember } from 'find-and-filter-data/view-members-schema/public';
import { getHasMore, getMembers, getTotalCount } from 'find-and-filter-data/view-members-schema/protected';
import { List } from 'immutable';
import { getUserId } from '../../selectors/userSelectors/getUserId';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SearchResultsContainer = ({
  threadId
}) => {
  const agentId = useSelector(getUserId);
  const inboxId = useSelector(getCurrentInboxId);
  const filterValues = useSelector(selectFilterValues);
  const portalId = PortalIdParser.get();
  const {
    sortOrder
  } = useSortOrder();
  const {
    filterResults,
    fetchMore: fetchMoreThreadListMembers,
    isRefetchingThreadListMembers,
    loading
  } = useSearchAndFilterThreadListMembers({
    filterValues,
    // @ts-expect-error ts-migrate(2322) FIXME: Type 'number | null' is not assignable to type 'nu... Remove this comment to see the full error message
    inboxId,
    // Turn off polling in search as an experiment to eventually remove it altogether.
    enablePolling: false,
    onFilterValueChange: values => {
      if (loading) {
        trackAppliedFilters(values, getTotalCount(filterResults));
      }
    },
    sortOrder
  });
  const focusedThreadListMember = useSelector(state => selectFilteredThreadListMemberWithThreadId(state, {
    threadId
  }));
  const filterKey = FilterKey({
    filterValues,
    sortOrder
  });
  useMarkViewMemberSeen({
    agentId,
    filterKey,
    inboxId,
    portalId: portalId,
    viewMember: focusedThreadListMember ? ThreadListMember(focusedThreadListMember) : undefined
  });
  const threadListMembers = filterResults ? getMembers(filterResults).toList() : List();
  const hasMoreThreadListMembers = filterResults ? getHasMore(filterResults) : false;
  const count = filterResults ? getTotalCount(filterResults) : 0;
  const fetchMore = fetchMoreThreadListMembers;
  const {
    navigateToThread
  } = useNavigateToThread();
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [!(isRefetchingThreadListMembers && loading) && /*#__PURE__*/_jsx(DisplayResultsText, {
      message: "conversations-inbox-ui.thread-search-and-filtering.thread-list-member-sidebar.displayResults",
      options: {
        count: count || 0
      }
    }), /*#__PURE__*/_jsx(VirtualizedThreadListMemberList, {
      fetchThreadListMembersPage: fetchMore,
      focusedThreadListMember: focusedThreadListMember,
      hasMoreThreadListMembers: hasMoreThreadListMembers,
      isLoadingThreadListMembers: loading,
      onSelectThread: navigateToThread,
      threadListMembers: threadListMembers,
      isRefetchingSearchResults: isRefetchingThreadListMembers
    })]
  });
};
SearchResultsContainer.displayName = 'SearchResultsContainer';
export default SearchResultsContainer;